export const DEFAULT_MIME_TYPE = 'audio/webm;codecs=opus'

export const DEFAULT_CHUNK_MS = 250

export const MediaRecorderState = {
  Inactive: 'inactive',
}

export const MicrophonePermissionName = 'microphone'

export const MicrophonePermissionErrorName = {
  NotAllowed: 'NotAllowedError',
  PermissionDenied: 'PermissionDeniedError',
  Security: 'SecurityError',
}

export const MicrophonePermissionState = {
  Denied: 'denied',
  Granted: 'granted',
  Prompt: 'prompt',
}
